import { h, Component } from 'preact';
import { COMPONENT_MAP } from './buttons';
export const CUSTOM_BUTTONS = ['download', 'isi', 'usersentiment', 'share', 'language', 'rewind', 'level', 'controls_settings'];
const TARGETED_BUTTONS = ['language', 'level'];
const MENU_TOGGLE_MAP = {
    level: 'showLevelMenu',
    language: 'showLanguageMenu'
};

export class ControlButtons extends Component {
    constructor(props) {
        super(props);

        this.state = {
            menus: this.defaultMenuStates,
            hasPill: false
        };
    }

    get defaultMenuStates () {
        return {
            showLevelMenu: false,
            showLanguageMenu: false,
        }
    }

    componentDidMount() {
        const { projectData = {} } = this.props;
        const { languages = [], levels = [] } = projectData;

        if (this.containsSpecified && languages.length && levels.length) {
            this.setState({ hasPill: true });
        }
    }

    onMenuToggle = toggleName => {
        const target = this.state.menus[toggleName];
        this.setState({menus: {...this.defaultMenuStates, [toggleName]: !target}});
    }

    get filteredKeys () {
        return Object.keys(this.props.list || {}).filter(key => CUSTOM_BUTTONS.indexOf(key) > -1 && this.props.list[key])
    }

    get containsSpecified () {
        const doesContain = item => this.filteredKeys.includes(item);
        return TARGETED_BUTTONS.every(doesContain);
    }

    get sortedKeys() {
        let keys = [...this.filteredKeys];

        if (this.containsSpecified) {
            const sinButtons = keys.filter(key => !TARGETED_BUTTONS.includes(key))
            keys = [...sinButtons, ...TARGETED_BUTTONS]; // ensure proper ordering of buttons
        }

        return keys;
    }

    render() {
        const { hasPill } = this.state;
        const className = `${ControlButtons.containerClassName} ${hasPill ? 'lang-level-pill' : ''}`;

        return (
            <div className={className}>
                {
                    this.sortedKeys.map(key => {
                            const Button = COMPONENT_MAP[key],
                                { state, ...props } = this.props;
                            const toggleKey = MENU_TOGGLE_MAP[key];
                            const toggleFn = toggleKey ? {toggleMenuOpen: this.onMenuToggle.bind(this, toggleKey)} : {};

                            return <Button { ...props } { ...state } {...toggleFn}
                                    onMenuToggle={this.onMenuToggle}
                                    menus={this.state.menus} />;
                        })
                }
            </div>
        )
    }
    static containerClassName = 'controlButtons'
}